import React,{useEffect} from "react";
import "./Homepage.css";
import AOS from "aos";


const VisionAndMission = () => {
  useEffect(()=>{
    AOS.init();
    window.scroll(0,0);
  },[])
  return (
    <div className="container-fluid" id="vision-and-mission">
      <div className="row top-row">
        <div className="col left-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000">
          <h1>Our <br /> Vision</h1>
        </div>
        <div className="col right-col" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000">
          <p>
            "Unique Technologies envisions a future where sustainable technology
            solutions empower communities worldwide. Through relentless
            innovation and a commitment to excellence, we aim to be a global
            leader in renewable energy, automation, and software development,
            driving positive change and advancing the way we live and work."
          </p>
        </div>
      </div>
      <hr />
      <div className="row bottom-row">
        <div className="col left-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000">
          <p>
            "At Unique Technologies, our mission is to revolutionize industries
            through innovative technology solutions. We strive to harness the
            power of renewable energy, automation, and software development to
            optimize processes, enhance efficiency, and create sustainable value
            for our clients, partners, and the planet."
          </p>
        </div>
        <div className="col right-col" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000">
          <h1>Our <br /> Mission</h1>
        </div>
      </div>
    </div>
  );
};

export default VisionAndMission;
